import { render, staticRenderFns } from "./ExpenseReportLineTableForm.vue?vue&type=template&id=20cbcb07&"
import script from "./ExpenseReportLineTableForm.vue?vue&type=script&lang=js&"
export * from "./ExpenseReportLineTableForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports